module.exports = __webpack_public_path__ + "img/IMG20190717154722.4434bc76.jpg";